export enum PlanningItemType {
    maintenance = 'maintenance',
    lead = 'lead',
    placement = 'placement',
    delivery = 'delivery',
    repair = 'repair',
}
